import { IEnvironment, EEnvironment } from '@shared/models'

export const environment: IEnvironment = {
	operationGateway: 'https://testzeegw.vemoit.com/oms/mex',
	gateway: 'https://testzeegw.vemoit.com',
	environment: EEnvironment.test,
	signinRedirectUrl: 'https://testzeeform.vemoit.com',
	signoutRedirectUrl: 'https://testzeeform.vemoit.com/logout',
}
